import { ITheme } from "../../utils/theme";

export const noDataTableWrapper = {
  paddingTop: 2,
  paddingBottom: 2,
  paddingRight: 1,
  paddingLeft: 1,
  marginTop: 1,
  marginBottom: 4,
  overflow: 'auto',
  borderRadius: '5px',
  background: "#E3E3E3",
  textAlign: 'center'
}

export const tableWrapper = {
  paddingRight: 1,
  paddingLeft: 1,
  paddingTop: 2,
  pb: 0,
  m: 1,
  overflowX: 'initial',
  borderRadius: '8px',
  border: 0,
  fontSize: '0.875rem',
  mb: 0,
  overflow: 'auto',
  '& .MuiTableCell-root': {
    padding: '1px',
    border: '1px solid #d1d3d4',
  }
}

export const noDataStyle = {
  background: '#D9D9D9',
  marginTop: '8px',
  marginBottom: '32px',
  paddingTop: '16px',
  paddingBottom: '16px',
  paddingLeft: '32px',
  paddingRight: '32px',
  textAlign: 'center',
  color: '#616161',
}

export const legendStyle = {
  paddingTop: '2px',
  paddingBottom: '2px',
  flexGrow: 1,
  minWidth: '700px',
  maxWidth: '700px',
  width: '100%'
}

export const currentDispStatusStyle = {
  width: '70vw',
}

export const greyHeaderStyle = (theme: ITheme) => ({
  textAlign: 'center',
  background: "#616161",
  margin: 0,
  padding: '1px',
  '& .MuiTableCell-root': {
    color: 'white',
  }
});

export const notNatcEmployeeStyle = {}

export const isWorkingButtonStyle = {
  backgroundColor: "#6b568a",
}

export const isReliefButtonStyle = {
  backgroundColor: "#6b568a",
}

export const isDayOffButtonStyle = {
  backgroundColor: "#cbc0c0",
  width: '40px',
  height: '9px',
  margin: 'auto',
}

export const notWorkingOrDayOffButtonStyle = {}

export const isLoggedInEmployeeStyle = {
  ' .notnatc': {
    textAlign: 'center',
    p: 0
  },
  '& .natc.MuiTableCell-root:nth-of-type(1)': {
    backgroundColor: "#616161",
    textAlign: 'center',
    color: '#F2F1E6',
    p: 0
  },
  '& .MuiTableCell-root:nth-of-type(2).isWorkingButtonStyle': {
    backgroundColor: "#6b568a",
    width: '40px',
    height: '9px',
    margin: 'auto',
  },
  '& .MuiTableCell-root:nth-of-type(2).isReliefButtonStyle': {
    backgroundColor: "#6b568a",
    width: '40px',
    height: '9px',
    margin: 'auto',
  },
  '& .MuiTableCell-root:nth-of-type(2).isDayOffButtonStyle': {
    backgroundColor: "#cbc0c0",
    width: '40px',
    height: '9px',
    margin: 'auto',
  },
  '& .MuiTableCell-root:nth-of-type(1), & .MuiTableCell-root:nth-of-type(2)': {
    width: '40px',
    background: (theme: ITheme) => theme.palette.grey.A350,
  },
  '& .MuiTableCell-root:nth-of-type(3), .MuiTableCell-root.orderDetail': {
    width: '80px',
  },
  '& .MuiTableCell-root:nth-of-type(3)': {
    background: (theme: ITheme) => theme.palette.grey.A350,
  },
  '& .MuiTableCell-root:nth-of-type(4)': {
    width: '150px',
    background: (theme: ITheme) => theme.palette.grey.A350,
  },
  '&.currentEmployee': {
    '& .MuiTableCell-root:nth-of-type(1)': {
      borderTop: '2px solid blue',
      borderLeft: '2px solid blue',
      borderBottom: '2px solid blue'
    },
    '& .MuiTableCell-root:nth-of-type(2), & .MuiTableCell-root:nth-of-type(3)': {
      borderTop: '2px solid blue',
      borderBottom: '2px solid blue'
    },
    '& .MuiTableCell-root:nth-of-type(4)': {
      borderTop: '2px solid blue',
      borderRight: '2px solid blue',
      borderBottom: '2px solid blue'
    },
  },
}

export const notLoggedInEmployeeStyle = {}

export const acceptanceImageStyle = {
  height: "inherit",
  padding: "1px",
  cursor: "pointer"
}

export const jobPickupStatusStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  '&.isAcceptedStyle': {
    backgroundColor: "#D0F5DA",
    height: '20px',
    border: '1px solid #b8b8b8',
    margin: 'auto',
  },
  '&.isSkippedStyle': {
    backgroundColor: "#616161",
    height: '20px',
    border: '1px solid #b8b8b8',
    margin: 'auto',
    color: '#F2F1E6',
    fontSize: '11px',
    textAlign: 'center',
  },
  '&.isAssignedStyle': {
    backgroundColor: "#FCB00A",
    height: '20px',
    border: '1px solid #b8b8b8',
    margin: 'auto',
  },
  '&.isDeclinedStyle': {
    backgroundColor: "#F53105",
    height: '20px',
    border: '1px solid #b8b8b8',
    margin: 'auto',
  },
  '&.isAcceptedAndCurrentStyle': {
    backgroundImage: 'url("../../../public/assets/images/lines/v_lg_g.png")',
    height: '15px',
  },
}
